// src/initTracking.ts
import {
  GoogleAnalyticsAdapter,
  KpPixelAdapter,
  MoengageAdapter,
  PixelAdapter,
  ShopifyAnalyticsAdapter,
  initializeEventTracking,
} from "@/events";

export async function initTracking() {
  // const kpPixelAdapter = new KpPixelAdapter({
  //   pixelId: process.env.NEXT_PUBLIC_PIXEL_ID ?? "",
  // });

  const pixelAdapter = new PixelAdapter({
    pixelId: process.env.NEXT_PUBLIC_PIXEL_ID ?? "",
  });

  const gaAdapter = new GoogleAnalyticsAdapter({
    measurementIds:
      process.env.NEXT_PUBLIC_GA_ID?.split(",").map((id) => id.trim()) ?? [],
  });

  const moengageAdapter = new MoengageAdapter({
    appId: process.env.NEXT_PUBLIC_MOENGAGE_APP_ID ?? "",
    enableUserIdentification: true,
    debug: process.env.NODE_ENV === "development",
    region: process.env.NEXT_PUBLIC_MOENGAGE_REGION, // Default region, can be configured via env var if needed
  });

  const shopifyAnalyticsAdapter = new ShopifyAnalyticsAdapter({
    shopId: process.env.NEXT_PUBLIC_SHOPIFY_SHOP_ID ?? "",
    currency: "INR", // Set to INR to match the cart events
  });

  await initializeEventTracking([
    // kpPixelAdapter,
    pixelAdapter,
    gaAdapter,
    moengageAdapter,
    shopifyAnalyticsAdapter,
  ]);
}
